// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { useFeatureFlags } from "@getbread/feature-flag-sdk-react";
import { addGlobalContext } from "@getbread/wheat-general";
import { useEffect } from "react";

declare global {
	interface Window {
		_fs_ready?: () => void;
	}
}

export const GlobalErrorContext = () => {
	const flags = useFeatureFlags();

	useEffect(() => {
		addGlobalContext({ flags });
	}, [flags]);

	return null;
};
